import { useExpander } from '@app/utils/hooks';
import { isDefined } from '@app/utils/is';
import cx from 'classnames';
import React from 'react';

import { Minus } from '../Icons';

interface Props {
  header: string;
  headerLevel: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  isExpanded: boolean;
  onToggleExpanded: VoidFunction;
  headerPrefix?: JSX.Element | string;
  headerPostfix?: JSX.Element | string;
}

export const Expander = ({
  header,
  headerLevel,
  isExpanded,
  onToggleExpanded,
  children,
  headerPostfix,
  headerPrefix,
}: React.PropsWithChildren<Props>) => {
  const Header = headerLevel;

  const { sectionProps, triggerProps, sectionClassName } = useExpander({ isExpanded });

  return (
    <div className="w-full rounded-regular bg-white px-5 py-3">
      <Header className="flex">
        <button
          className="-mx-5 -my-3 flex w-full flex-grow items-center justify-between gap-3 rounded-regular px-5 py-3 text-neutral-60 heading-4"
          type="button"
          onClick={onToggleExpanded}
          {...triggerProps}
        >
          <span className="flex gap-2">
            {isDefined(headerPrefix) && <span>{headerPrefix}</span>}
            <span>{header}</span>
            {isDefined(headerPostfix) && <span>{headerPostfix}</span>}
          </span>
          <span className="relative h-4 w-3 text-neutral-20">
            <Minus width={16} className="absolute" />
            <Minus width={16} className={cx('absolute motion-safe:transition-transform', { 'rotate-90': !isExpanded })} />
          </span>
        </button>
      </Header>
      <section {...sectionProps} className={sectionClassName}>
        <div className="-m-1 overflow-hidden p-1">
          <div className="mt-3">{children}</div>
        </div>
      </section>
    </div>
  );
};
